import React from 'react'

import {
  RootProvider,
  AlertProvider,
  MessageModalProvider,
  PropertyProvider,
  FilterProvider,
  ListProvider,
  LocalityModalProvider,
  HomeProvider,
} from 'store'

const StateProvider = ({ children }) => (
  <RootProvider>
    <PropertyProvider>
      <AlertProvider>
        <ListProvider>
          <FilterProvider>
            <MessageModalProvider>
              <HomeProvider>
                <LocalityModalProvider>{children}</LocalityModalProvider>
              </HomeProvider>
            </MessageModalProvider>
          </FilterProvider>
        </ListProvider>
      </AlertProvider>
    </PropertyProvider>
  </RootProvider>
)

export default StateProvider
